import React, { memo, useContext } from 'react';

import { Block } from '../../components/core';
import { TextFormatContent } from './text-format-content';
import { DragHandle } from '../../components/core/block-header/block-header-top-container';
import { DRAG_HANDLE_CLASS } from '../../../utils';
import { useRecoilValue } from 'recoil';
import { isReportState } from 'venn-state';
import { useAppPrintMode } from '../../../print';
import { UserContext } from '../../../contexts';
import { cn } from '@/lib/utils';

interface TextFormatBlockProps {
  id: string;
}

export const TextFormatBlock = memo(function InternalTextFormatBlock({ id }: TextFormatBlockProps) {
  const { hasPermission } = useContext(UserContext);
  const isReport = useRecoilValue(isReportState);
  const { inPrintMode } = useAppPrintMode();

  return (
    <Block.Root id={id}>
      <Block.Content id={id}>
        <TextFormatContent id={id} />
      </Block.Content>
      <div className={cn('absolute top-[0.7rem] right-[0.7rem]')}>
        {isReport && !inPrintMode && hasPermission('STUDIO_REORDER_BLOCKS') && (
          <DragHandle type="arrows" className={DRAG_HANDLE_CLASS} />
        )}
      </div>
    </Block.Root>
  );
});
